module.exports = "img/flags/SH.1f71963.png";